module.exports = __webpack_public_path__ + "img/icon_anonbud_other.e5405b2c.svg";